import { forwardRef } from "react";
import { ReportTable } from "@/components/ReportTable";
import { GcStatement } from "@/components/GcStatement";
import { Logo } from "@/components/Logo";
import { SignatureBlock } from "@/components/SignatureBlock";
import { periodLabel } from "@/lib/finance";
import { fmtDate, todayISO } from "@/lib/format";

export const AnnualReport = forwardRef(function AnnualReport({ year, inProgress, scope, sections, gc, period, rangeLabel, sig, heading }, ref) {
  const cal = rangeLabel || (inProgress ? `January 1, ${year} – ${fmtDate(todayISO())}` : `January 1 – December 31, ${year}`);
  return (
    <div ref={ref} data-annual-doc className="annual-doc rounded-xl bg-white p-6 text-slate-900 shadow-sm sm:p-10" data-testid="annual-report-doc">
      <div className="flex flex-col gap-4 border-b-2 border-slate-800 pb-5 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-4">
          <Logo className="h-16 w-16 border border-slate-200" />
          <div className="pt-1">
            <div className="font-heading text-2xl font-extrabold leading-normal text-slate-900" data-testid="annual-title">{rangeLabel ? heading.title : `${heading.title} ${year}`}</div>
            <div className="text-sm text-slate-600" data-testid="annual-subtitle">{heading.subtitle}</div>
            {heading.showing && <div className="mt-1 text-sm font-bold text-slate-900" data-testid="report-showing">{heading.showing}</div>}
          </div>
        </div>
        <div className="text-sm text-slate-600 sm:text-right">
          {gc && <div><span className="font-semibold">Financial report:</span> {rangeLabel || periodLabel(period)}</div>}
          {sections.length > 0 && <div><span className="font-semibold">{gc ? "Church tables:" : "Period:"}</span> {cal}</div>}
          <div><span className="font-semibold">Churches:</span> {scope}</div>
          <div><span className="font-semibold">Generated:</span> {fmtDate(todayISO())}</div>
          {inProgress && <div className="mt-2 text-xs font-semibold text-slate-600" data-testid="annual-in-progress">Year in progress — totals so far</div>}
        </div>
      </div>
      <div className="mt-6 space-y-8">
        {gc && <GcStatement model={gc} period={period} label={rangeLabel} />}
        {sections.map((s, i) => <ReportTable key={s.title} section={s} testid={`annual-section-${i}`} />)}
      </div>
      <SignatureBlock sig={sig} className="px-0" />
    </div>
  );
});
